import Model from '@/models/Model'

export default class Vehicle extends Model {
	primaryKey() {
		return 'id'
	}

	resource() {
		return 'v2/vehicles'
	}

	toJSON() {
		return { ...this }
	}
}
